import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import BaseInput from '../BaseInput';
import CInput from '../CInput';
export default function BasicInput(_ref, props) {
  var _ref$value = _ref.value,
      value = _ref$value === void 0 ? '' : _ref$value,
      change = _ref.change,
      setRef = _ref.setRef;
  return {
    defaultValue: '',
    Wrapper: BaseInput,
    contentProps: {
      empty: value == null || value === '',
      children: /*#__PURE__*/React.createElement(CInput, _extends({
        setRef: setRef,
        onChange: function onChange(e) {
          change(e.target.value);
        },
        value: value,
        className: "jmtd-input-input"
      }, props))
    }
  };
}